class InView {
    constructor() {
        this.hasSupport = false;

        if ('IntersectionObserver' in window) {
            let options = {
                rootMargin: '0px',
                threshold: [0.0, 0.1]
            };
            this.hasSupport = true;
            this.observer = new IntersectionObserver(this.callback.bind(this) , options);
        }

        this.addDefaultElements();
        this.setEvents();
    }

    callback(elements) {
        elements.forEach(element => {
            if (element.intersectionRatio > 0) {
                let event = new CustomEvent('inView',{ 'detail' : elements });
                element.target.dispatchEvent( event );
                this.observer.unobserve(element.target);

                if(element.target.classList.contains('js-in-view')){
                    element.target.classList.add('in-view');
                }
            }
        });
    }

    addDefaultElements(root = document) {
        let defaultElements = document.querySelectorAll('.js-in-view');
        defaultElements.forEach(element => {
            if(element.dataset.inview == true) return;
            this.addElement(element);
        });
    }

    addElement( el ) {
        el.dataset.inview = true;
        if(this.hasSupport) this.observer.observe(el);
        else el.classList.add('in-view');
    }

    setEvents() {
        window.addEventListener('inview-reload', this.e_reload.bind(this));
        window.addEventListener('inview-add', this.e_add.bind(this));

    }

    e_reload() {
        this.addDefaultElements();
    }

    e_add(e) {
        this.addElement(e.details.el);
    }

}

let instance = new InView();

export default instance;
